import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import { FaTwitter } from "react-icons/fa";
import styled from "styled-components";
import { trackClipSocialShare, trackCreatorCardShare } from "./utils";

const StyledShare = styled(FaTwitter)`
  color: #f8fcfd;
`;

export default function TwitterShare({ link, clip, card, ...props }) {
  return (
    <>
      <ShareButton
        title="Share to Twitter"
        justifyContent={"center"}
        alignItems="center"
        flex={true}
        display="flex"
        href={`https://twitter.com/intent/tweet?url=${link}&text=${props.title}`}
        target="_blank"
        onClick={() => {
          if (clip) {
            trackClipSocialShare({
              platform: "Twitter",
              isMontage: clip.isMontage,
              clip,
            });
          } else if (card) {
            trackCreatorCardShare(card);
          }
        }}
        {...props}
      >
        <StyledShare size={24}></StyledShare>

        {props.children}
      </ShareButton>
    </>
  );
}
